import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "flex col align-center p24"
}
const _hoisted_4 = {
  class: "flex align-center justify-center col",
  style: {"margin-top":"200px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: "/ico/logo.svg" }, null, -1)
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 2,
  class: "flex col p12 g12 grow"
}
const _hoisted_8 = {
  key: 0,
  class: "flex grow align-center justify-center"
}
const _hoisted_9 = { class: "flex g12" }
const _hoisted_10 = { style: {"flex":"1 0 0"} }
const _hoisted_11 = { style: {"flex":"2 0 0"} }
const _hoisted_12 = { class: "flex g12" }
const _hoisted_13 = { style: {"flex":"1 0 0"} }
const _hoisted_14 = {
  key: 0,
  style: {"flex":"1 0 0"}
}
const _hoisted_15 = { class: "flex align-center" }
const _hoisted_16 = { style: {"flex":"1 0 0","min-width":"0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_AdminHome = _resolveComponent("AdminHome")!
  const _component_DatabaseStoreSelection = _resolveComponent("DatabaseStoreSelection")!
  const _component_SeLoadingIndicator = _resolveComponent("SeLoadingIndicator")!
  const _component_RestaurantScore = _resolveComponent("RestaurantScore")!
  const _component_Tasks = _resolveComponent("Tasks")!
  const _component_CommunicationAndTraining = _resolveComponent("CommunicationAndTraining")!
  const _component_EquipementTemperatures = _resolveComponent("EquipementTemperatures")!
  const _component_EmployeeSchedule = _resolveComponent("EmployeeSchedule")!
  const _component_BestStores = _resolveComponent("BestStores")!
  const _component_Audits = _resolveComponent("Audits")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavHeader, {
      title: _ctx.Lang.getI18N('home')
    }, null, 8, ["title"]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_AdminHome)
        ]))
      : _createCommentVNode("", true),
    (_ctx.role == _ctx.Role.Distributor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.Lang.getI18N("welcome-to-secureat")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.role == _ctx.Role.Admin || _ctx.role == _ctx.Role.Customer || _ctx.role == _ctx.Role.Manager)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_DatabaseStoreSelection, {
            ref: "selector",
            valueChange: _ctx.homeState.onSelectionChanged
          }, null, 8, ["valueChange"]),
          (_ctx.homeState.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_SeLoadingIndicator)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.homeState.selectedStore != null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          (_ctx.role != _ctx.Role.Manager)
                            ? (_openBlock(), _createBlock(_component_RestaurantScore, { key: 0 }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          (_ctx.role != _ctx.Role.Manager)
                            ? (_openBlock(), _createBlock(_component_Tasks, { key: 0 }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_CommunicationAndTraining)
                        ]),
                        (_ctx.role != _ctx.Role.Manager)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_EquipementTemperatures)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_EmployeeSchedule)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_CommunicationAndTraining, { style: {"flex":"1 0 0"} }),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_BestStores)
                        ])
                      ]),
                      _createVNode(_component_Audits)
                    ], 64))
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}